export const isClosed = trade => ['WIN', 'LOSS', 'BE'].includes(trade.result);
export const number = value => { const parsed = Number.parseFloat(String(value ?? '').replace(/%/g, '')); return Number.isFinite(parsed) ? parsed : 0; };
export const localDate = (date = new Date()) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

export function filterPeriod(trades, period, now = new Date()) {
  if (period === 'all') return trades;
  const start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  start.setDate(start.getDate() - (period === 'month' ? 29 : 89));
  return trades.filter(t => t.date >= localDate(start) && t.date <= localDate(now));
}

export function journalMetrics(trades) {
  const closed = trades.filter(isClosed).sort((a, b) => (a.date || '').localeCompare(b.date || '') || number(a.createdAt) - number(b.createdAt));
  const wins = closed.filter(t => t.result === 'WIN').length;
  const losses = closed.filter(t => t.result === 'LOSS').length;
  let total = 0, peak = 0, drawdown = 0, grossWin = 0, grossLoss = 0;
  const points = [{ value: 0, date: '', label: 'Starting point' }];
  const sessions = {};
  closed.forEach(trade => {
    const value = number(trade.returnPct);
    total += value;
    peak = Math.max(peak, total);
    drawdown = Math.max(drawdown, peak - total);
    if (value > 0) grossWin += value;
    if (value < 0) grossLoss += Math.abs(value);
    points.push({ value: total, date: trade.date, label: trade.instrument, trade, change: value });
    const session = trade.session || 'Unspecified';
    sessions[session] = (sessions[session] || 0) + value;
  });
  const winningRR = closed.filter(t => t.result === 'WIN' && number(t.rr) > 0);
  const decisive = closed.filter(t => t.result !== 'BE').reverse();
  let streak = 0;
  for (const trade of decisive) { if (trade.result !== decisive[0].result) break; streak++; }
  return { closed, wins, losses, total, drawdown, points, sessions,
    breakEven: closed.length - wins - losses,
    winRate: wins + losses ? wins / (wins + losses) * 100 : null,
    profitFactor: grossLoss ? grossWin / grossLoss : grossWin ? Infinity : null,
    avgRR: winningRR.length ? winningRR.reduce((sum, t) => sum + number(t.rr), 0) / winningRR.length : null,
    streak, streakType: decisive[0]?.result,
  };
}

export function csvCell(value) {
  const text = String(value ?? '');
  // Keep formulas supplied in journal text from running in spreadsheet apps.
  const safe = /^\s*[=+@-]/.test(text) && !/^[-+]?\d+(\.\d+)?%?$/.test(text.trim()) ? `'${text}` : text;
  return `"${safe.replace(/"/g, '""')}"`;
}

export function createRecordId() {
  return window.crypto?.randomUUID?.() || `${Date.now().toString(36)}${Math.random().toString(36).slice(2)}`;
}
